// Define the possible steps in the provider payment flow
// Refactored from enum to constant object
export const ProviderPaymentStep = {
    SELECT_PROVIDER: 'SELECT_PROVIDER',
    CONFIRM_PROVIDER: 'CONFIRM_PROVIDER',
    ADD_DETAILS: 'ADD_DETAILS',
    UPLOAD_DOCUMENTS: 'UPLOAD_DOCUMENTS',
    CHOOSE_PURSES: 'CHOOSE_PURSES',
    SELECT_EXPENSE_TYPE: 'SELECT_EXPENSE_TYPE',
    EXPENSE_ALLOCATION: 'EXPENSE_ALLOCATION',
    REVIEW: 'REVIEW',
} as const;
// Type for the step values

export type ProviderPaymentStepType = (typeof ProviderPaymentStep)[keyof typeof ProviderPaymentStep];
